function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9994 23.4306C11.0036 23.4306 9.92445 23.9166 8.80939 24.6297L8.80121 24.6349C7.27185 25.6045 6.10056 27.0751 5.52153 28.8179H12.3296C13.7055 28.8179 14.8208 29.9332 14.8208 31.309C14.8208 32.6849 13.7055 33.8002 12.3296 33.8002H2.62983C1.254 33.8002 0.138672 32.6849 0.138672 31.309C0.138672 26.7128 2.54256 22.7055 6.12924 20.4296C7.8909 19.3038 9.88719 18.4483 12.9994 18.4483C16.1956 18.4483 18.1178 19.31 19.8694 20.4295C23.4562 22.7054 25.8602 26.7127 25.8602 31.309C25.8602 32.6849 24.7449 33.8002 23.369 33.8002C21.9932 33.8002 20.8779 32.6849 20.8779 31.309C20.8779 28.4967 19.4136 26.0398 17.1977 24.6349L17.1895 24.6297C16.0646 23.9104 15.06 23.4306 12.9994 23.4306Z",
  fill: "white",
  fillOpacity: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9994 10.7723C14.543 10.7723 15.7943 9.52098 15.7943 7.9774C15.7943 6.43382 14.543 5.18251 12.9994 5.18251C11.4558 5.18251 10.2045 6.43382 10.2045 7.9774C10.2045 9.52098 11.4558 10.7723 12.9994 10.7723ZM20.7766 7.9774C20.7766 12.2726 17.2946 15.7546 12.9994 15.7546C8.70418 15.7546 5.22221 12.2726 5.22221 7.9774C5.22221 3.68217 8.70418 0.200195 12.9994 0.200195C17.2946 0.200195 20.7766 3.68217 20.7766 7.9774Z",
  fill: "white",
  fillOpacity: 0.5
});

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34,
    viewBox: "0 0 26 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a8f821e0.svg";
export { ForwardRef as ReactComponent };